import { lazy } from 'react'

export const WeAllGainWeight = lazy(() => import('./WeAllGainWeight'))
